// extracted by mini-css-extract-plugin
export default {"map":"YaMap_map__sMRbQ","markerContainer":"YaMap_markerContainer__MVqBf","markerText":"YaMap_markerText__6jGlt"};